export function getBlankNextPreviousInfo() {
  return {
    id: null,
    available: false,
    atLimit: false,
    loadPage: false
  };
}

export function deepCopy(item) {
  return JSON.parse(JSON.stringify(item));
}

export function deepCopyAxiosException(e) {
  // Axios no longer includes the http response in the json serialisation (via its custom .toJSON() method),
  // but we need it to show server-side errors - so revert back to the native json serialisation
  e.toJSON = undefined;
  return JSON.parse(JSON.stringify(e));
}
